module.exports = __webpack_public_path__ + "img/sssss.a2af2707.jpg";